import { combineReducers } from "@reduxjs/toolkit";
import common from "./commonSlice";
import statesDistricts from "./statesDistrictsSlice";

const reducer = combineReducers({
  common,
  statesDistricts,
});

export default reducer;
